import { FC } from 'react';

const AboutPage: FC = () => {
    return (
        <>
            <hr />
            <h1>AboutPage</h1>
            <hr />
        </>
    );
};

export default AboutPage;
